window.addEventListener('scroll',()=>{
  document.getElementById('mainNav').classList.toggle('sc',scrollY>60);
  var p=scrollY/(document.body.scrollHeight-window.innerHeight);
  document.getElementById('dfill').style.height=(p*100)+'%';
  document.getElementById('dval').textContent=Math.round(p*300)+'m';
  document.getElementById('dbtn').classList.toggle('vis',scrollY>200);
},{passive:true});

(function(){
  var obs=new IntersectionObserver(function(es){
    es.forEach(function(e){if(e.isIntersecting)e.target.classList.add('v');});
  },{threshold:.1});
  document.querySelectorAll('.rv,.rl,.rr').forEach(function(el){obs.observe(el);});
})();

/* ONE-LINE BUBBLES — canvas z:3 above text z:2 */
(function(){
  var sec=document.getElementById('one-line');
  var cv=document.createElement('canvas');
  cv.style.cssText='position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:3';
  sec.insertBefore(cv,sec.firstChild);
  var ctx=cv.getContext('2d');
  function sz(){cv.width=sec.offsetWidth;cv.height=sec.offsetHeight;}
  sz();window.addEventListener('resize',sz);
  var bb=[];
  for(var i=0;i<65;i++){
    bb.push({x:Math.random(),y:1.1+Math.random()*.45,r:.8+Math.random()*3.8,
      vy:-(0.45+Math.random()*1.4),vx:(Math.random()-.5)*.003,
      a:.08+Math.random()*.28,w:Math.random()*6.28,ws:.01+Math.random()*.022,done:false});
  }
  var fired=false;
  function draw(){
    var W=cv.width,H=cv.height;
    if(!W||!H){sz();W=cv.width;H=cv.height;}
    ctx.clearRect(0,0,W,H);var alive=false;
    for(var i=0;i<bb.length;i++){
      var b=bb[i];if(b.done)continue;
      b.y+=b.vy/H;b.w+=b.ws;b.x+=Math.sin(b.w)*.003+b.vx;
      var px=b.x*W,py=b.y*H;
      if(py+b.r<0){b.done=true;continue;}
      alive=true;
      var fade=py<H*.18?Math.max(0,py/(H*.18)):1,a=b.a*fade;
      ctx.save();ctx.beginPath();ctx.arc(px,py,b.r,0,6.28);
      var g=ctx.createRadialGradient(px-b.r*.3,py-b.r*.3,b.r*.1,px,py,b.r);
      g.addColorStop(0,'rgba(195,242,255,'+(a*.9)+')');
      g.addColorStop(.6,'rgba(80,185,230,'+(a*.35)+')');
      g.addColorStop(1,'rgba(30,110,190,0)');
      ctx.fillStyle=g;ctx.fill();
      ctx.strokeStyle='rgba(220,250,255,'+(a*.45)+')';ctx.lineWidth=.35;ctx.stroke();
      ctx.restore();
    }
    if(alive)requestAnimationFrame(draw);else ctx.clearRect(0,0,W,H);
  }
  var obs=new IntersectionObserver(function(es){
    if(es[0].isIntersecting&&!fired){fired=true;obs.disconnect();
      setTimeout(function(){sz();requestAnimationFrame(draw);},120);}
  },{threshold:.1});
  obs.observe(sec);
})();

/* SLIDESHOW */
(function(){
  var sl=document.querySelectorAll('.fsl'),dt=document.querySelectorAll('.fdot'),pr=document.getElementById('fProg');
  var cur=0,ti,pt,pv=0,D=5500;
  function go(n){
    sl[cur].classList.remove('on');dt[cur].classList.remove('on');
    cur=(n+sl.length)%sl.length;
    sl[cur].classList.add('on');dt[cur].classList.add('on');
    clearInterval(pt);pv=0;pr.style.width='0%';
    pt=setInterval(function(){pv+=100/(D/80);pr.style.width=Math.min(pv,100)+'%';},80);
  }
  function au(){ti=setInterval(function(){go(cur+1);},D);}
  document.getElementById('fNext').onclick=function(){clearInterval(ti);go(cur+1);au();};
  document.getElementById('fPrev').onclick=function(){clearInterval(ti);go(cur-1);au();};
  dt.forEach(function(d){d.onclick=function(){clearInterval(ti);go(+d.dataset.i);au();};});
  var tx=0,fc=document.getElementById('fc');
  fc.ontouchstart=function(e){tx=e.touches[0].clientX;};
  fc.ontouchend=function(e){var dx=e.changedTouches[0].clientX-tx;if(Math.abs(dx)>50){clearInterval(ti);go(dx<0?cur+1:cur-1);au();}};
  au();go(0);
})();

/* GALLERY — infinite seamless loop, no gaps */
(function(){
  var wrap=document.querySelector('.glw');
  var tr=document.getElementById('glTrack');
  var ds=document.querySelectorAll('#glDots .gld');
  var origItems=Array.from(tr.querySelectorAll('.gli'));
  var N=origItems.length;

  // clone all items and append for seamless loop
  origItems.forEach(function(el){
    var cl=el.cloneNode(true);
    tr.appendChild(cl);
  });

  var cur=0,isAnimating=false;
  tr.style.transition='none';

  function gw(){return window.innerWidth<=900?window.innerWidth*.85:window.innerWidth*.48;}

  function updateDots(i){
    ds.forEach(function(d,j){d.classList.toggle('on',j===(i%N));});
  }

  function go(n){
    if(isAnimating)return;
    isAnimating=true;
    cur=n;
    tr.style.transition='transform .75s cubic-bezier(.4,0,.2,1)';
    tr.style.transform='translateX('+(-(cur*gw()))+'px)';
    updateDots(cur);
    setTimeout(function(){
      // if we've gone past original set, jump back silently
      if(cur>=N){
        cur=cur-N;
        tr.style.transition='none';
        tr.style.transform='translateX('+(-(cur*gw()))+'px)';
      } else if(cur<0){
        cur=cur+N;
        tr.style.transition='none';
        tr.style.transform='translateX('+(-(cur*gw()))+'px)';
      }
      isAnimating=false;
    },780);
  }

  document.getElementById('glNext').onclick=function(){go(cur+1);};
  document.getElementById('glPrev').onclick=function(){go(cur-1);};
  ds.forEach(function(d,i){d.onclick=function(){go(i);};});

  var tx=0;
  tr.ontouchstart=function(e){tx=e.touches[0].clientX;};
  tr.ontouchend=function(e){var dx=e.changedTouches[0].clientX-tx;if(Math.abs(dx)>50)go(dx<0?cur+1:cur-1);};

  window.addEventListener('resize',function(){
    tr.style.transition='none';
    tr.style.transform='translateX('+(-(cur*gw()))+'px)';
  });

  // autoplay
  setInterval(function(){go(cur+1);},4200);

  // init
  tr.style.transform='translateX(0)';
  updateDots(0);
})();

/* CASEBACK rotation + bubbles */
(function(){
  var img=document.getElementById('cuImg'),cv=document.getElementById('cuCanvas'),box=document.querySelector('.cubox');
  if(!img||!cv||!box)return;
  var ctx=cv.getContext('2d'),angle=0,raf,bbActive=false,bb=[];
  function szC(){cv.width=box.offsetWidth;cv.height=box.offsetHeight;}
  function mkBb(){
    bb=[];
    for(var i=0;i<40;i++)
      bb.push({x:.1+Math.random()*.8,y:1.05+Math.random()*.3,r:.5+Math.random()*3,
        vy:-(0.4+Math.random()*1.1),vx:(Math.random()-.5)*.002,
        a:.07+Math.random()*.22,w:Math.random()*6.28,ws:.01+Math.random()*.02,done:false});
  }
  function drawBb(){
    var W=cv.width,H=cv.height;ctx.clearRect(0,0,W,H);var alive=false;
    for(var i=0;i<bb.length;i++){
      var b=bb[i];if(b.done)continue;
      b.y+=b.vy/H;b.w+=b.ws;b.x+=Math.sin(b.w)*.002+b.vx;
      var px=b.x*W,py=b.y*H;
      if(py+b.r<0){b.done=true;continue;}
      alive=true;
      var fade=py<H*.2?Math.max(0,py/(H*.2)):1,a=b.a*fade;
      ctx.save();ctx.beginPath();ctx.arc(px,py,b.r,0,6.28);
      var g=ctx.createRadialGradient(px-b.r*.3,py-b.r*.3,b.r*.1,px,py,b.r);
      g.addColorStop(0,'rgba(200,240,255,'+(a*.9)+')');
      g.addColorStop(.6,'rgba(80,175,230,'+(a*.35)+')');
      g.addColorStop(1,'rgba(30,100,180,0)');
      ctx.fillStyle=g;ctx.fill();
      ctx.strokeStyle='rgba(220,248,255,'+(a*.4)+')';ctx.lineWidth=.3;ctx.stroke();
      ctx.restore();
    }
    if(!alive)setTimeout(mkBb,1800);
  }
  function loop(){angle+=0.22;img.style.transform='rotate('+angle+'deg)';drawBb();raf=requestAnimationFrame(loop);}
  var obs=new IntersectionObserver(function(es){
    if(es[0].isIntersecting){szC();if(!bbActive){mkBb();bbActive=true;}loop();}
    else cancelAnimationFrame(raf);
  },{threshold:.2});
  obs.observe(box);
  window.addEventListener('resize',szC);
})();

function playVideo(btn){
  var w=btn.closest('.vidw');
  if(!w||w.querySelector('iframe'))return;
  w.innerHTML='<iframe class="vid-iframe" src="https://player.vimeo.com/video/1173849761?badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&controls=1&loop=1" allow="autoplay;fullscreen;picture-in-picture" allowfullscreen></iframe>';
}
